import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_screen/affiliate/$id")({
  component: AffiliateDetailPage
})

import { Navigate } from "@tanstack/react-router"
import { useEffect } from "react"

import { useShowAffiliate } from "@/modules/helpers/hooks/shared"

function AffiliateDetailPage() {
  const { id } = Route.useParams()
  const { setId } = useShowAffiliate()

  useEffect(() => {
    if (id) {
      setId(id)
    }
  }, [id, setId])

  return <Navigate to="/affiliate" />
}
